const LinksData = [
  {
    _id: "01",
    category: "Educational",
    name: "Notes",
    description: "Top Free Notes Website",
    LabelTags: [],
    iconLink: "images/notes.svg",
    Link: [
      {
        _id: "01A",
        siteName: "IIT KGP Library",
        siteLink: "https://ndl.iitkgp.ac.in/",
      },
      {
        _id: "01B",
        siteName: "Notes Corner",
        siteLink: "https://csenotescorner.blogspot.com/search/label/home",
      },
      {
        _id: "01C",
        siteName: "Technical Symposium",
        siteLink: "https://www.technicalsymposium.com/alllecturenotes_csc.html",
      }
    ],
  },
  {
    _id: "02",
    category: "Educational",
    name: "Books",
    description: "Top Free Book Websites",
    LabelTags: [],
    iconLink: "images/books.svg",
    Link: [
      {
        _id: "02A",
        siteName: "Library Genesis",
        siteLink: "http://libgen.rs/",
      },
      {
        _id: "02B",
        siteName: "National Digital Library - IIT KGP",
        siteLink: "https://ndl.iitkgp.ac.in/",
      },
      {
        _id: "02C",
        siteName: "PDF Drive",
        siteLink: "https://www.pdfdrive.com/",
      },
    ],
  },
  {
    _id: "03",
    category: "Educational",
    name: "Courses",
    description: "Free Courses from top Institutions",
    LabelTags: [],
    iconLink: "images/courses.svg",
    Link: [
      {
        _id: "03A",
        siteName: "Harvard University",
        siteLink: "https://pll.harvard.edu/catalog/free",
      },
      {
        _id: "03B",
        siteName: "FreeCodeCamp",
        siteLink: "https://www.freecodecamp.org/learn",
      },
      {
        _id: "03C",
        siteName: "Khan Academy",
        siteLink: "https://www.khanacademy.org/",
      },
      {
        _id: "03D",
        siteName: "Google Courses",
        siteLink: "https://learndigital.withgoogle.com/digitalgarage/",
      },
      {
        _id: "03E",
        siteName: "NPTEL",
        siteLink: "https://nptel.ac.in/courses",
      },
    ],
  },
  // {
  //   _id: "04",
  //   category: "Educational",
  //   name: "Mentors",
  //   description: "",
  //   LabelTags: [],
  //   iconLink: "images/",
  //   Link: [
  //     {
  //       _id: "04A",
  //       siteName: "",
  //       siteLink: "",
  //     },
  //     {
  //       _id: "04B",
  //       siteName: "",
  //       siteLink: "",
  //     },
  //     {
  //       _id: "04C",
  //       siteName: "",
  //       siteLink: "",
  //     },
  //     {
  //       _id: "04D",
  //       siteName: "",
  //       siteLink: "",
  //     },
  //   ],
  // },

  {
    _id: "06",
    category: "Educational",
    name: "Internship",
    description: "Internships Website",
    LabelTags: [],
    iconLink: "images/internships.svg",
    Link: [
      {
        _id: "06A",
        siteName: "InternShala",
        siteLink: "https://internshala.com/",
      },
      {
        _id: "06B",
        siteName: "Indeed",
        siteLink: "https://in.indeed.com/",
      },
      {
        _id: "06C",
        siteName: "LinkedIn",
        siteLink: "https://www.linkedin.com/jobs/internship-jobs/?originalSubdomain=in",
      },
    ],
  },
  {
    _id: "07",
    category: "Entertainment",
    name: "Sports Streaming",
    description: "Watch Cricket & other Sports Live.",
    LabelTags: [],
    iconLink: "images/sports.svg",
    Link: [
      {
        _id: "07A",
        siteName: "My Live Cricket",
        siteLink: "http://iplt20.mylivecricket.live/",
      },
      {
        _id: "07B",
        siteName: "Pikashow",
        siteLink: "https://pikashow.cc/pikachu",
      },
      {
        _id: "07C",
        siteName: "IPL DS",
        siteLink: "https://ipldekh.site/",
      },
    ],
  },
  {
    _id: "08",
    category: "Entertainment",
    name: "Online Live TV",
    description: "Watch LIVE TV for Free",
    LabelTags: [],
    iconLink: "images/online-tv.svg",
    Link: [
      {
        _id: "08A",
        siteName: "Pikashow",
        siteLink: "https://pikashow.cc/pikachu",
      },
      {
        _id: "08B",
        siteName: "HD Streamz",
        siteLink: "https://apksunny.com/hd-streamz-18/",
      }
    ],
  },
  {
    _id: "09",
    category: "Entertainment",
    name: "Movies",
    description: "Download / Watch Movies for Free !",
    LabelTags: [],
    iconLink: "images/movies.svg",
    Link: [
      {
        _id: "09A",
        siteName: "Moviesverse",
        siteLink: "https://moviesverse.asia/",
      },
      {
        _id: "09B",
        siteName: "SD Movies Point",
        siteLink: "https://www.google.com/search?q=sdmoviespoint",
      },
      {
        _id: "09C",
        siteName: "UwatchFree",
        siteLink: "https://uwatchfreemovies.online/",
      },
      {
        _id: "09D",
        siteName: "Cineb",
        siteLink: "https://www1.cineb.co/",
      },
      {
        _id: "09E",
        siteName: "Sflix",
        siteLink: "https://sflix.pro/home",
      },
    ],
  },
  // {
  //   _id: "11",
  //   category: "Entertainment",
  //   name: "Song Downloader",
  //   description: "",
  //   LabelTags: [],
  //   iconLink: "images/song.svg",
  //   Link: [
  //     {
  //       _id: "11A",
  //       siteName: "",
  //       siteLink: "",
  //     },
  //     {
  //       _id: "11B",
  //       siteName: "",
  //       siteLink: "",
  //     },
  //     {
  //       _id: "11C",
  //       siteName: "",
  //       siteLink: "",
  //     },
  //     {
  //       _id: "11D",
  //       siteName: "",
  //       siteLink: "",
  //     },
  //   ],
  // },
  {
    _id: "12",
    category: "Tools",
    name: "PC Softwares",
    description: "Download Premium PC Apps for Free!",
    LabelTags: [],
    iconLink: "images/pc-apps.svg",
    Link: [
      {
        _id: "12A",
        siteName: "GetIntoPC [BEST]",
        siteLink: "https://getintopc.com/",
      },
      {
        _id: "12B",
        siteName: "File Hippo",
        siteLink: "https://filehippo.com/",
      },
    ],
  },
  {
    _id: "13",
    category: "Tools",
    name: "Diagram Creator",
    description: "Online Diagram creator tool",
    LabelTags: [],
    iconLink: "images/diagram-creators.svg",
    Link: [
      {
        _id: "13A",
        siteName: "Draw.io",
        siteLink: "https://draw.io/",
      },
      {
        _id: "13B",
        siteName: "Lucid Chart",
        siteLink: "https://www.lucidchart.com/pages/examples/diagram-maker",
      },
      {
        _id: "13C",
        siteName: "Whimsical",
        siteLink: "https://whimsical.com/",
      },
      {
        _id: "13D",
        siteName: "Creately",
        siteLink: "https://creately.com/",
      },
    ],
  },
  {
    _id: "15",
    category: "Tools",
    name: "PC Games",
    description: "Download premium PC Games for Free!",
    LabelTags: [],
    iconLink: "images/pc-games.svg",
    Link: [
      {
        _id: "15A",
        siteName: "Ocean Of Games",
        siteLink: "https://oceansofgamess.com/",
      },
      {
        _id: "15B",
        siteName: "UpToDown",
        siteLink: "https://en.uptodown.com/windows/games",
      },
    ],
  },
  {
    _id: "16",
    category: "Tools",
    name: "Meme Creators",
    description: "Free Meme Creators",
    LabelTags: [],
    iconLink: "images/meme.svg",
    Link: [
      {
        _id: "16A",
        siteName: "Img Flip",
        siteLink: "https://imgflip.com/memegenerator",
      },
      {
        _id: "16B",
        siteName: "Adobe Meme Creator",
        siteLink: "https://www.adobe.com/express/create/meme",
      },
      {
        _id: "16C",
        siteName: "Canava Meme Creator",
        siteLink: "https://www.canva.com/create/memes/",
      },
    ],
  },
  {
    _id: "17",
    category: "Tools",
    name: "Wallpapers",
    description: "4K Wallpapers",
    LabelTags: [],
    iconLink: "images/wallpaper.svg",
    Link: [
      {
        _id: "17A",
        siteName: "Wallpapers",
        siteLink: "https://wallpapers.com/",
      },
      {
        _id: "17B",
        siteName: "PEXELS",
        siteLink: "https://www.pexels.com/search/desktop%20backgrounds/",
      },
      {
        _id: "17C",
        siteName: "Wallpaper Access",
        siteLink: "https://wallpaperaccess.com/pc",
      },
    ],
  },
  {
    _id: "18",
    category: "Tools",
    name: "PDF Tools",
    description: "Edit PDFs for Free",
    LabelTags: [],
    iconLink: "images/pdf.svg",
    Link: [
      {
        _id: "18A",
        siteName: "Small PDF",
        siteLink: "https://smallpdf.com/edit-pdf",
      },
      {
        _id: "18B",
        siteName: "Sejda",
        siteLink: "https://www.sejda.com/pdf-editor",
      },
      {
        _id: "18C",
        siteName: "PDF.io",
        siteLink: "https://pdf.io/",
      },
      {
        _id: "18D",
        siteName: "Text to Handwriting",
        siteLink: "https://saurabhdaware.github.io/text-to-handwriting/",
      },
    ],
  },
  {
    _id: "19",
    category: "Tools",
    name: "Daily Usage Tools",
    description: "Best Free online Tools",
    LabelTags: [],
    iconLink: "images/daily-tools.svg",
    Link: [
      {
        _id: "19A",
        siteName: "All in one",
        siteLink: "https://123apps.com/",
      },
      {
        _id: "19B",
        siteName: "Temporary Mail",
        siteLink: "https://temp-mail.org/en/",
      },
      {
        _id: "19C",
        siteName: "DP Maker",
        siteLink: "https://pfpmaker.com/",
      },
      {
        _id: "19D",
        siteName: "Alternatives To",
        siteLink: "https://alternativeto.net/",
      },
    ],
  },
  {
    _id: "20",
    category: "Tools",
    name: "Video Editors",
    description: "Online Free Video Editors",
    LabelTags: [],
    iconLink: "images/video-editor.svg",
    Link: [
      {
        _id: "20A",
        siteName: "Veed",
        siteLink: "https://www.veed.io/",
      },
      {
        _id: "20B",
        siteName: "Jitter",
        siteLink: "https://jitter.video/",
      },
      {
        _id: "20C",
        siteName: "123Apps",
        siteLink: "https://online-video-cutter.com/video-editor",
      },
      {
        _id: "20D",
        siteName: "Video BG remover",
        siteLink: "https://www.unscreen.com/",
      },
    ],
  },
  {
    _id: "21",
    category: "Tools",
    name: "Photo Editors",
    description: "Online Free Photo Editor Tools",
    LabelTags: [],
    iconLink: "images/photo-editor.svg",
    Link: [
      {
        _id: "21A",
        siteName: "PhotoPea",
        siteLink: "https://www.photopea.com/",
      },
      // {
      //   _id: "21B",
      //   siteName: "",
      //   siteLink: "",
      // },
      {
        _id: "21C",
        siteName: "Enhance Quality",
        siteLink: "https://letsenhance.io/",
      },
      {
        _id: "21D",
        siteName: "Colorize Pics",
        siteLink: "https://hotpot.ai/colorize-picture",
      },
      {
        _id: "21E",
        siteName: "Remove BG",
        siteLink: "https://www.remove.bg/",
      },
    ],
  },
  {
    _id: "22",
    category: "Dev Tools",
    name: "CSS Tools",
    description: "Best CSS tools for awesome design.",
    LabelTags: [],
    iconLink: "images/css.svg",
    Link: [
      {
        _id: "22A",
        siteName: "BG Gradients",
        siteLink: "https://webgradients.com/",
      },
      {
        _id: "22B",
        siteName: "CSS Cheat Sheet",
        siteLink: "https://htmlcheatsheet.com/css/",
      },
      {
        _id: "22C",
        siteName: "Color Picker",
        siteLink: "https://chrome.google.com/webstore/detail/colorpick-eyedropper/ohcpnigalekghcmgcdcenkpelffpdolg?hl=en",
      },
      {
        _id: "22D",
        siteName: "Google Fonts",
        siteLink: "https://fonts.google.com/",
      },
    ],
  },
  {
    _id: "23",
    category: "Dev Tools",
    name: "Logo Makers",
    description: "Best Free Logo Makers",
    LabelTags: [],
    iconLink: "images/logo-maker.svg",
    Link: [
      {
        _id: "23A",
        siteName: "AI Logo Maker",
        siteLink: "https://brandmark.io/",
      },
      {
        _id: "23B",
        siteName: "Looka",
        siteLink: "https://looka.com/logo-maker/",
      },
      {
        _id: "23C",
        siteName: "Cavna",
        siteLink: "https://www.canva.com/create/logos/",
      },
      {
        _id: "23D",
        siteName: "Adobe Logo Maker",
        siteLink: "https://www.adobe.com/express/create/logo",
      },
    ],
  },
  {
    _id: "24",
    category: "Dev Tools",
    name: "Online Coding Platforms",
    description: "Practice coding online",
    LabelTags: [],
    iconLink: "images/online-code.svg",
    Link: [
      {
        _id: "24A",
        siteName: "Leetcode",
        siteLink: "https://leetcode.com/",
      },
      {
        _id: "24B",
        siteName: "Interview Bit",
        siteLink: "https://www.interviewbit.com/",
      },
      {
        _id: "24C",
        siteName: "IndiaBix",
        siteLink: "https://www.indiabix.com/",
      },
    ],
  },
  // {
  //   _id: "25",
  //   category: "Dev Tools",
  //   name: "Diagram Creators",
  //   description: "",
  //   LabelTags: [],
  //   iconLink: "images/diagram-creators.svg",
  //   Link: [
  //     {
  //       _id: "25A",
  //       siteName: "",
  //       siteLink: "",
  //     },
  //     {
  //       _id: "25B",
  //       siteName: "",
  //       siteLink: "",
  //     },
  //     {
  //       _id: "25C",
  //       siteName: "",
  //       siteLink: "",
  //     },
  //     {
  //       _id: "25D",
  //       siteName: "",
  //       siteLink: "",
  //     },
  //   ],
  // },
  {
    _id: "26",
    category: "Dev Tools",
    name: "WebDev Tools",
    description: "Useful tools for Web Development.",
    LabelTags: [],
    iconLink: "images/website.svg",
    Link: [
      {
        _id: "26A",
        siteName: "Free APIs",
        siteLink: "https://github.com/public-apis/public-apis/blob/master/README.md",
      },
      {
        _id: "26B",
        siteName: "Pesticide",
        siteLink: "https://chrome.google.com/webstore/detail/pesticide-for-chrome-with/neonnmencpneifkhlmhmfhfiklgjmloi",
      },
      {
        _id: "26C",
        siteName: "Free Icons",
        siteLink: "https://freeicons.io/",
      },
      // {
      //   _id: "26D",
      //   siteName: "",
      //   siteLink: "",
      // },
    ],
  },
];


export default LinksData;